import { GzDashboardDiscardChangesDialogContentWebComponent } from './component/GzDashboardDiscardChangesDialogContentWebComponent';

export { GzDashboardDiscardChangesDialogContentWebComponent };
